;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import cx from 'classnames';
import PropTypes from 'prop-types';

import SvgIcon from 'components/ui/SvgIcon';
import Text from 'components/ui/Text';

import styles from './CreameryDiningHours.module.scss';

const iconTypeMap = {
    'Yogurt Cup': 'yogurtCup',
    Utensils: 'utensils',
    'Ice Cream Cone': 'iceCreamCone',
    'Coffee Cup': 'coffeeCup',
};

const CreameryDiningHours = ({ eyebrow, richHeadline, list }) => {
    return (
        <div className={styles.creameryDiningHoursFlex}>
            <div className={styles.creameryDiningHours}>
                <div className={styles.richEyebrow}>
                    {eyebrow && (
                        <div className={styles.eyebrow}>
                            <Text
                                baseTheme={'labelSmall'}
                                themes={{ medium: 'labelLarge' }}
                                as="h3"
                            >
                                {eyebrow}
                            </Text>
                        </div>
                    )}
                    {richHeadline && (
                        <>
                            <div className={styles.headline}>
                                {richHeadline?.json.content.map((line, i) => {
                                    if (line.content[0].value === '') {
                                        return null;
                                    }
                                    return (
                                        <Text
                                            key={i}
                                            as="h3"
                                            baseTheme="displayXSmall"
                                            themes={{
                                                medium: 'displayLarge',
                                            }}
                                        >
                                            {line.content[0].value}
                                        </Text>
                                    );
                                })}
                            </div>
                        </>
                    )}
                </div>
                {list && (
                    <ul className={styles.list}>
                        {list.map((item, i) => {
                            return (
                                <li key={i} className={styles.listItem}>
                                    <div className={styles.listItemLabel}>
                                        <div
                                            className={styles.listItemLabelIcon}
                                        >
                                            <div
                                                className={cx(
                                                    styles.listItemLabelIconInner,
                                                    styles[
                                                        iconTypeMap[item.icon]
                                                    ]
                                                )}
                                            >
                                                <SvgIcon
                                                    type={
                                                        iconTypeMap[item.icon]
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <Text
                                            as="div"
                                            baseTheme="labelSmall"
                                            themes={{
                                                xxLarge: 'labelLarge',
                                            }}
                                            className={styles.listItemLabelText}
                                        >
                                            {item.label}
                                        </Text>
                                    </div>
                                    <Text
                                        as="div"
                                        baseTheme="bodySmall"
                                        className={styles.listItemValue}
                                    >
                                        {item?.value?.replace(/\|/g, '\n')}
                                    </Text>
                                </li>
                            );
                        })}
                    </ul>
                )}
            </div>
        </div>
    );
};

CreameryDiningHours.propTypes = {
    eyebrow: PropTypes.string,
    richHeadline: PropTypes.object,
    list: PropTypes.array,
};

export default CreameryDiningHours;
